if (!customElements.get("cc-faqs")) {
  customElements.define(
    "cc-faqs",
    class CCFaqs extends HTMLElement {
      constructor() {
        super();
        this.onHashChange = this.onHashChange.bind(this);
      }

      connectedCallback() {
        window.addEventListener("hashchange", this.onHashChange);
        this.openMatchingDropdown();
      }

      disconnectedCallback() {
        window.removeEventListener("hashchange", this.onHashChange);
      }

      onHashChange() {
        this.openMatchingDropdown();
      }

      openMatchingDropdown() {
        const hash = location.hash.toLowerCase();
        const matching_dropdown = this.querySelector(`[data-anchor="${hash}"]`);
        if (matching_dropdown) {
          matching_dropdown.setAttribute("open", "true");
        }
      }
    },
  );
}
